import { render, staticRenderFns } from "./OwnerConsentTypeSelect.vue?vue&type=template&id=cbf345b2&scoped=true&lang=pug"
import script from "./OwnerConsentTypeSelect.vue?vue&type=script&lang=js"
export * from "./OwnerConsentTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf345b2",
  null
  
)

export default component.exports